import {Observable, OperatorFunction, timer} from 'rxjs';
import {switchMap} from 'rxjs/operators';

/**
 * Wartet nach jedem Wert `quietMs` Millisekunden und lädt dann über `load` – nur für den jeweils
 * neuesten Wert.
 *
 * <p>Anders als `debounceTime(quietMs)` vor `switchMap` bricht jeder neue Wert eine laufende Anfrage
 * **sofort** ab, nicht erst nach der Wartezeit. Sonst kann die Antwort zu einem älteren Wert noch im
 * Wartefenster eintreffen und als Ergebnis für den neuen Wert gelten (Vorschau im
 * Zeitplan-Popup: alte Termine, „Speichern“ freigegeben).
 */
export function switchMapAfterQuiet<T, R>(
  quietMs: number,
  load: (value: T) => Observable<R>,
): OperatorFunction<T, R> {
  return switchMap(value => timer(quietMs).pipe(switchMap(() => load(value))));
}
